import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'
import { match } from 'ts-pattern'

import { Numeric } from '@blade/ui-kit'
import { nativeNetworkCurrencyAtom } from '@root/entities/currency'
import { NetworkIcon } from '@root/entities/network/ui'

import { positionTableCurrencyTypeAtom } from '../atoms'

import type { ClassNameProps } from '@root/shared/react'
import type BigNumber from 'bignumber.js'

type PositionsTableAmountCellProps = {
  amountUsd: BigNumber
  amountNative: BigNumber
  amountCurrency: BigNumber
  type: 'bought' | 'sold' | 'remaining'
} & ClassNameProps

export const PositionsTableAmountCell: React.FC<
  PositionsTableAmountCellProps
> = ({ className, amountUsd, amountNative, amountCurrency, type }) => {
  const [currencyType] = useAtom(positionTableCurrencyTypeAtom)

  const [nativeCurrency] = useAtom(nativeNetworkCurrencyAtom)
  const amount = currencyType === 'native' ? amountNative : amountUsd

  return (
    <Root className={className}>
      <Amount $type={type}>
        <Numeric
          value={amount}
          preset="currency-amount-short"
          currency={currencyType === 'native' ? undefined : '$'}
        />
        {currencyType === 'native' && (
          <NetworkIcon size={14} network={nativeCurrency.network} />
        )}
      </Amount>
      <AmountCurrency>
        <Numeric value={amountCurrency} preset="currency-amount-short" />
      </AmountCurrency>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  gap: 1px;
`

const Amount = styled.div<{ $type: PositionsTableAmountCellProps['type'] }>`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;

  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: start;
  gap: 2px;

  color: ${({ $type }) =>
    match($type)
      .with('bought', () => 'var(--up-9)')
      .with('sold', () => 'var(--down-9)')
      .with('remaining', () => 'var(--background-11)')
      .exhaustive()};
`

const AmountCurrency = styled.div`
  color: var(--text-11);
  font-size: 10px;
  font-weight: 500;
  line-height: 12px;
`
